import React from 'react';
import av from "../assets/images/default-avatar.png";

const Testimonials = () => {
    return (
        <section id="testimonials" className="testimonials-clean">
            <div className="container">
                <div className="row">
                    <div className="col col-md-10 mx-auto">
                        <h2 className="text-dark">Your voice is our strength</h2>
                        <p>It's really overwhelming to serve you the best. It's been the same pleasure as much as yours for our symbiotic ventures.<br /></p>
                    </div>
                </div>
                <div className="row people">
                    <div className="col-md-6 col-lg-4 item">
                        <div className="box">
                            <p className="description">Thank you for creating customized logo for our tea company. It was upto the mark and we are satisfied.<br /></p>
                        </div>
                        <div className="author">
                            <img className="rounded-circle" src={av} alt="Author" />
                            <h5 className="name">Madhurjya Borah</h5>
                            <p className="title">Bhairabi Tea</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 item">
                        <div className="box">
                            <p className="description">It's really been a great satisfaction for us to work with you. Fantastic co-operation and timely delivery.<br /></p>
                        </div>
                        <div className="author">
                            <img className="rounded-circle" src={av} alt="Author" />
                            <h5 className="name">Director</h5>
                            <p className="title">J. J. R. Junior College</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 item">
                        <div className="box">
                            <p className="description">It's been a great fun and enjoyable learning with you. I have learned a lot about Tally with practical approaches.<br /></p>
                        </div>
                        <div className="author">
                            <img className="rounded-circle" src={av} alt="Author" />
                            <h5 className="name">Manash Talukdar</h5>
                            <p className="title">Self-employed</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Testimonials
